import * as React from 'react';
import { AlertSuccess } from '../../components/alerts';
import { SuccessMessageProps } from './types';

const SuccessMessage = ({ message }: SuccessMessageProps) => <AlertSuccess>{message}</AlertSuccess>;

export default SuccessMessage;
